import { EntityStore } from 'app/interfaces/store';

const addRequestId = <T = string>(state: Partial<EntityStore>, status: T, requestId: string) => {
  state.status?.[status as unknown as string].push(requestId);
};

const removeRequestId = <T>(state: Partial<EntityStore>, status: T, requestId: string) => {
  if (state.status) {
    state.status[status as unknown as string] = state.status?.[status as unknown as string]?.filter(
      (id: string) => requestId !== id
    );
  }
};

export const entityStoreStatus = { removeRequestId, addRequestId };
